import { Component, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { StepperService } from './services/stepperService/stepper.service';
import { PsqServiceService } from './services/commonService/psq-service.service';
import { FlightSearchModel } from './models/interface/FlightSearch/FlightSearchModel.interface';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from './shared/common/common.service';
import { ToastrApiService } from './shared/common/toastr-api.service';
import { LangResourceService } from './services/commonService/lang-resource.service';
import { CompanyManagementService } from './services/dataLayer/CAM/company-management.service';
import { PreviousPageCaptureService } from './services/dataLayer/previous-page-capture.service';

import { CamService } from './services/camService/cam.service';
import { AuthService } from '@auth0/auth0-angular';
import { PreviousPageCaptureBksService } from './services/dataLayer/previous-page-capture-bks.service';
import { PreviousPageCapturePolicyBksService } from './services/dataLayer/previous-page-capture-policy-bks.service';
import { environment } from 'src/environments/environment';
import { ToasterNotificationsComponent } from './shared/components/toaster-notifications/toaster-notifications.component';
import { CookieBannerComponent } from './shared/components/cookie-banner/cookie-banner.component';
import { SafeRedirectService } from './shared/common/safe-redirect.service';
import { IdleService } from './services/idle.service';


import { AuthServiceService } from './services/authService/auth-service.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, ToasterNotificationsComponent, CookieBannerComponent]
})
export class AppComponent implements OnInit, AfterViewInit {
  toastrData: any;
  resource: any;
  // This will handle tab/browser close
  @HostListener('window:beforeunload', ['$event'])
  clearStorage(_event: Event) {
    // This listener is intentionally left blank to allow Angular
    // to intercept the browser/tab close event if needed.
  }

  constructor(
    private readonly matIconReg: MatIconRegistry,
    private readonly translateService: TranslateService,
    private readonly _Router: Router,
    private readonly _StepperService: StepperService,
    private readonly _PsqServiceService: PsqServiceService,
    private readonly _MatDialog: MatDialog,
    private readonly _CommonService: CommonService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly langResourceService: LangResourceService,
    private readonly _CompanyManagementService: CompanyManagementService,
    private readonly navService: PreviousPageCaptureService,
    private readonly navServiceBks: PreviousPageCaptureBksService,
    private readonly navServicePolicyBks: PreviousPageCapturePolicyBksService,
    private readonly camService: CamService,
    private readonly psqService: PsqServiceService,
    private readonly auth: AuthService,
    private readonly safeRedirect: SafeRedirectService,
    private readonly idleService: IdleService,
    private readonly authServiceService: AuthServiceService
  ) {
    this._CommonService.allPagesContentLoad();
    const userLang = navigator.language || 'en';
    const languageCode = userLang.split('-')[0];
    this.translateService.setDefaultLang(languageCode);
    this.translateService.use(languageCode);
    this._Router.events.subscribe(($router: any) => {
      if ($router instanceof NavigationStart) {
        this._StepperService.stepperCommonFunc($router.url);
        this._CompanyManagementService.routeUrl.nextRoute = $router.url;
        this._CompanyManagementService.routeUrl.currentRoute = this._Router.url;
        // Store route history
        this.navServiceBks.setCurrentUrl($router.url);
        this.navServicePolicyBks.setCurrentUrl($router.url);

        let stepperFindIndex = this._StepperService?.[
          this._StepperService?.currentStepper
        ]?.findIndex(($step: any) => $router.url.includes($step.path));
        if (stepperFindIndex != -1) {
          this._StepperService.updateStep(stepperFindIndex);
        }
        if (
          !$router.url.toLocaleLowerCase().includes('payment') &&
          !$router.url.toLocaleLowerCase().includes('flight-cancellation')
        ) {
          sessionStorage.removeItem('ORDERID');
        }
        this.bindSelectPlaceholderNgMultiSelect();

        // this is for session timeout
        const isLoggedIn = !!sessionStorage.getItem('QlAccessToken');
        if (isLoggedIn) {
          this.idleService.startWatching();
          this.authServiceService.startTokenRefreshLoop();
          this.authServiceService.startAuth0TokenRefreshLoop();
        } else {
          this.idleService.stopWatching();
          this.authServiceService.stopTokenRefreshLoop();
          this.authServiceService.stopAuth0TokenRefreshLoop();
        }
        this.navService.setCurrentUrl = this._CompanyManagementService.routeUrl.nextRoute;
        this.navService.setPreviousUrl = this._CompanyManagementService.routeUrl.currentRoute;
      }
    });
    this._ToastrApiService.toastrNotifications.subscribe((data) => {
      this.toastrData = data;
      setTimeout(() => {
        this.toastrData = null;
      }, 5000);
    });
    sessionStorage.removeItem('previousPage');
    // [TEMP DISABLED - testing click-blocking / Page Unresponsive issue on SIT/UAT]
    // this.loadGoogleTagManager()
  }


  ngOnInit(): void {
    // const currentPath = window.location.pathname;
    // const referrer = document.referrer;

    // if (currentPath.toLowerCase().startsWith('/business')) {
    //   // Agar referrer empty hai aur session me verified nahi hai, matlab direct access
    //   if ((!referrer || referrer === '') && sessionStorage.getItem('isB2BAccessAllowed') !== 'true') {
    //     window.location.href = 'https://prod.dcloud.saudia.com/en-IN/business/';
    //     return;
    //   } else {
    //     // Referrer hai ya already verified hai, toh session me save kar lein taki refresh pe redirect na ho
    //     sessionStorage.setItem('isB2BAccessAllowed', 'true');
    //   }
    // }

    const queryParams = new URLSearchParams(window.location.search);
    const error = queryParams.get('error');
    const errorDescription = queryParams.get('error_description');
    if (
      error &&
      (
        error === 'access_denied' ||
        error === 'invalid_request' ||
        error === 'unauthorized' ||
        errorDescription?.toLowerCase().includes('authentication') ||
        errorDescription?.toLowerCase().includes('access expired')
      )
    ) {
      console.log('CIAM Error (App Level):', error, errorDescription);
      setTimeout(() => {
        this._Router.navigate(['/validatelogin'], {
          queryParams: {
            error,
            error_description: errorDescription
          }
        });
      }, 0);

      return;
    }
    // Workaround for environments without SPA deep-link rewrites:
    // open root URL with `?redirect=<encoded>` then navigate client-side.
    try {
      const url = new URL(window.location.href);
      const redirectKey = url.searchParams.get('redirectKey');
      if (redirectKey) {
        const storedRedirect = localStorage.getItem(redirectKey);
        if (storedRedirect?.trim().startsWith('/') && !storedRedirect.trim().startsWith('//')) {
          localStorage.removeItem(redirectKey);
          const safeRedirect = this.safeRedirect.getSafeReturnUrl(storedRedirect);
          this._Router.navigateByUrl(safeRedirect, { replaceUrl: true });
          return;
        }
        url.searchParams.delete('redirectKey');
        globalThis.history.replaceState({}, '', `${url.pathname}${url.search}`);
      }
      const redirect = url.searchParams.get('redirect');
      if (redirect) {
        const decoded = decodeURIComponent(redirect).trim();
        if (decoded.startsWith('/') && !decoded.startsWith('//')) {
          const safeRedirect = this.safeRedirect.getSafeReturnUrl(decoded);
          this._Router.navigateByUrl(safeRedirect, { replaceUrl: true });
          return;
        }
        url.searchParams.delete('redirect');
        globalThis.history.replaceState({}, '', `${url.pathname}${url.search}`);
      }
    } catch {
      // ignore
    }

    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'logout-event') {
        this.handleGlobalLogout();
      }
    });
    // FIX: Use take(1) — this only needs to run ONCE on startup to rehydrate
    // the BehaviorSubject from sessionStorage if the page was refreshed.
    // Without take(1), this subscription stays alive forever and triggers
    // multiple flight search API calls every time searchPayloadSource emits null.
    this._PsqServiceService.currentSearchPayload.pipe(take(1)).subscribe(($payload) => {
      if (!$payload && !!JSON.parse(sessionStorage.getItem('psq') as string)) {
        this._PsqServiceService.searchPayloadSource.next(
          JSON.parse(sessionStorage.getItem('psq') as FlightSearchModel | any)
        );
      }
    });

    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
    // this.langResourceService.loadResourceLang('en-IN').subscribe(() => { });
    this.langResourceService.onResourceLangChange().subscribe((langCode) => { });

  }
  title = 'CBT';
  ngAfterViewInit() {
    this._CommonService.WINDOW_SIZE.width = innerWidth;
    this._CommonService.WINDOW_SIZE.height = innerHeight;
    this._MatDialog.afterOpened.subscribe(($res: any) => {
      this._CommonService.bindClassMatDialog();
      this.bindSelectPlaceholderNgMultiSelect(true);
    });
    this._MatDialog.afterAllClosed.subscribe(($res: any) => {
      if (document.body.classList.contains('overflow-hidden')) {
        document.body.classList.remove('overflow-hidden');
      }
    });
    window.addEventListener('DOMContentLoaded', () => {
      this.bindSelectPlaceholderNgMultiSelect();
    });
    window.addEventListener('resize', () =>
      this._CommonService.bindClassMatDialog()
    );
  }
  bindSelectPlaceholderNgMultiSelect(isMatOpened: boolean = false) {
    setTimeout(() => {
      document
        .querySelectorAll(".custom-ng-multiple-chip div[role='combobox'] input")
        ?.forEach(($input: any) => {
          $input.placeholder = 'Select';
        });
    }, 3000);
    if (isMatOpened) {
      setTimeout(() => {
        if (document.querySelectorAll('.custom-ng-multiple-chip')?.length) {
          document.body.classList.add('overflow-hidden');
        }
      }, 500);
    }
  }
  handleGlobalLogout() {
    this.psqService.clearStoredData();
    this.auth.logout();
  }


  private loadGoogleTagManager(): void {

    const gtmId = environment.gtm?.gtmId;

    if (!gtmId) return;

    // avoid duplicate loading
    if (document.getElementById('dynamic-gtm')) {
      return;
    }

    const dataLayer = (globalThis as typeof globalThis & { dataLayer?: Record<string, unknown>[] }).dataLayer ?? [];
    (globalThis as typeof globalThis & { dataLayer: Record<string, unknown>[] }).dataLayer = dataLayer;
    dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.id = 'dynamic-gtm';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    const noscript = document.createElement('noscript');
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

  }
}
